module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1158.e882fb65.jpg";